var _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSwap = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 100 101",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 47,
  transform: "rotate(90 50 50)",
  fill: "#1F1F1F",
  stroke: "#333333",
  strokeWidth: 6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M53.9999 34.8L64.3999 43.6L42.7999 43.6M35.5999 43.6L37.1999 43.6",
  stroke: "url(#paint0_linear_48_1486)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9999 65.2001L35.5999 56.4001L57.1999 56.4001M64.3999 56.4001L62.7999 56.4001",
  stroke: "url(#paint1_linear_48_1486)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_48_1486",
  x1: 64.3999,
  y1: 34.8,
  x2: 59.4813,
  y2: 50.8972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF75A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2FD1C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_48_1486",
  x1: 35.5999,
  y1: 65.2001,
  x2: 40.5184,
  y2: 49.103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF75A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A2FD1C"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/swap.33343823.svg";
export { ForwardRef as ReactComponent };